import { ContentNode } from '@amzn/awscat-pattern-library-service-model';
import { TiptapOutputType } from '@amzn/awscat-editor';

/**
 * Returns the URL-friendly identifier for a content node.
 * Prefers `href` (human-readable slug) over `id` (UUID). This value is what
 * gets written into `#contents?section=<value>` when a page or section is selected.
 */
export function sectionIdForNode(node: ContentNode): string {
  return node.href && node.href.length > 0 ? node.href : node.id;
}

/** Returns the DOM id used as the scroll target for a section ID. */
export function sectionScrollTargetId(sectionId: string): string {
  return `content-section-${encodeURIComponent(sectionId)}`;
}

/** Returns the DOM id used as the scroll target for a Pattern section. */
export function sectionScrollTargetIdForNode(node: ContentNode): string {
  return sectionScrollTargetId(sectionIdForNode(node));
}

/**
 * Returns the plain-text label to show for a node in navigation and the table of contents.
 * Prefers the optional short title, falling back to the full title when the short title is absent
 * or blank. Callers pass their `useEntityConverter` result as `entityConverter`.
 */
export function navigationLabelForNode(
  node: ContentNode,
  entityConverter: (value: TiptapOutputType) => string,
): string {
  const shortLabel = node.shortTitle ? entityConverter(node.shortTitle) : '';
  return shortLabel.trim().length > 0 ? shortLabel : entityConverter(node.title);
}
